import { cn } from '@/lib/utils'
import {
  SIZE_STYLES,
  TextElementProps,
  VARIANT_STYLES,
} from '@/components/common/textElements/Paragraph.tsx'

const Span = ({
  className,
  size = 'copySm',
  variant = 'default',
  text,
  children,
}: TextElementProps) => {
  return (
    <span className={cn(VARIANT_STYLES[variant], SIZE_STYLES[size], className)}>
      {text ?? children}
    </span>
  )
}
export default Span
